import { useTranslation } from 'react-i18next'

import { useEmitter } from '@shared/lib/emitter'
import Button, { type ButtonSizeVariant } from '@shared/ui/button'

interface AddToCartProps {
  className?: string;
  size?: ButtonSizeVariant
  onClick?: () => void;
}

export default function AddToCart (props: AddToCartProps) {
  const { size = 'medium', className, onClick } = props
  const { t: tp } = useTranslation('product')
  const { emitter } = useEmitter()

  const handleClick = () => {
    emitter.emit('addCartProduct')

    if (onClick) {
      onClick()
    }
  }

  return (
    <Button
      className={className}
      type="submit"
      size={size}
      theme="primary"
      onClick={handleClick}
    >
      {tp('in_cart.1')}
    </Button>
  )
}
